export const LOGIN_HANDLE_CHANGE = "LOGIN_HANDLE_CHANGE";
export const SIGNUP_HANDLE_CHANGE = "SIGNUP_HANDLE_CHANGE";
export const GLOBAL_AVAILABLE_CREDITS = "GLOBAL_AVAILABLE_CREDITS";
export const BLOCKED_CREDITS = "BLOCKED_CREDITS";

export const SERVICE_ENDPOINT = "http://localhost:3005/";

//LOGIN
export const LOGIN_ACTION = "LOGIN_ACTION";
export const LOGIN_ACTION_SUCCEEDED = "LOGIN_ACTION_SUCCEEDED";
export const LOGIN_ACTION_FAILED = "LOGIN_ACTION_FAILED";

//LOGOUT
export const LOGOUT_ACTION = "LOGOUT_ACTION";
export const LOGOUT_ACTION_SUCCEEDED = "LOGOUT_ACTION_SUCCEEDED";
export const LOGOUT_ACTION_FAILED = "LOGOUT_ACTION_FAILED";

//SIGNUP

export const SIGNUP_ACTION = "SIGNUP_ACTION";
export const SIGNUP_ACTION_SUCCEEDED = "SIGNUP_ACTION_SUCCEEDED";
export const SIGNUP_ACTION_FAILED = "SIGNUP_ACTION_FAILED";

export const FETCH_COUNTRIES_REQUEST = 'FETCH_COUNTRIES_REQUEST';
export const FETCH_COUNTRIES_SUCCESS = 'FETCH_COUNTRIES_SUCCESS';
export const FETCH_COUNTRIES_FAILURE = 'FETCH_COUNTRIES_FAILURE';


//FileUpload

export const SET_FILE = "SET_FILE";
export const SET_FILE_SUCCEEDED = "SET_FILE_SUCCEEDED";
export const SET_FILE_FAILED = "SET_FILE_FAILED";

//Single Email Validation

export const VALIDATE_EMAIL = "VALIDATE_EMAIL";
export const VALIDATE_EMAIL_CHANGE = "VALIDATE_EMAIL_CHANGE";
export const VALIDATE_EMAIL_SUCCEEDED = "VALIDATE_EMAIL_SUCCEEDED";
export const VALIDATE_EMAIL_FAILED = "VALIDATE_EMAIL_FAILED";
export const VALIDATE_EMAIL_CLEAR = "VALIDATE_EMAIL_CLEAR";

export const LOAD_DASHBOARD_DETAILS = "LOAD_DASHBOARD_DETAILS";
export const LOAD_DASHBOARD_DETAILS_SUCCEEDED = "LOAD_DASHBOARD_DETAILS_SUCCEEDED";
export const LOAD_DASHBOARD_DETAILS_FAILED = "LOAD_DASHBOARD_DETAILS_FAILED";

export const LOAD_UPLOADED_FILES = "LOAD_UPLOADED_FILES";
export const LOAD_UPLOADED_DETAILS_SUCCEEDED = "LOAD_UPLOADED_DETAILS_SUCCEEDED";
export const ADD_INPROCESS = "ADD_INPROCESS";
export const LOAD_UPLOADED_DETAILS_FAILED = "LOAD_UPLOADED_DETAILS_FAILED";
export const LOAD_SINGLE_EMAILS = "LOAD_SINGLE_EMAILS";
export const CLEAR_SINIGLE_EMAILS_DATA = "CLEAR_SINIGLE_EMAILS_DATA";
export const LOAD_SINGLE_EMAILS_SUCCEEDED = "LOAD_SINGLE_EMAILS_SUCCEEDED";

export const START_BULK_VALIDATION = "START_BULK_VALIDATION";
export const START_BULK_VALIDATION_FAILED = "START_BULK_VALIDATION_FAILED";
export const START_BULK_VALIDATION_SUCCEEDED = "START_BULK_VALIDATION_SUCCEEDED";

export const BULK_RE_VALIDATION = "START_BULK_RE_VALIDATION";
export const BULK_RE_VALIDATION_FAILED = "START_BULK_RE_VALIDATION_FAILED";
export const BULK_RE_VALIDATION_SUCCEEDED = "START_BULK_RE_VALIDATION_SUCCEEDED";

export const SHOW_CONFIRMATION = "SHOW_CONFIRMATION";
export const HIDE_CONFIRMATION = "HIDE_CONFIRMATION";
export const GET_LOGIN_USER_PROFILE_STATUS = "GET_LOGIN_USER_PROFILE_STATUS";
export const DISPLAY_COMPANY_PROFILE_POPUP = "DISPLAY_COMPANY_PROFILE_POPUP";

// switch_tab
export const SWITCH_TAB = "SWITCH_TAB";

export const DELETE_BULK_VALIDATION = "DELETE_BULK_VALIDATION";
export const DOWNLOAD_REPORT = "DOWNLOAD_REPORT";
export const DOWNLOAD_SINGLE_REPORT = "DOWNLOAD_SINGLE_REPORT";
//Plan subscription
export const SUBSCRIBE_PLAN = "SUBSCRIBE_PLAN";
export const SUBSCRIBE_PLAN_SUCCEDED = "SUBSCRIBE_PLAN_SUCCEDED";
export const SUBSCRIBE_PLAN_FAILED = "SUBSCRIBE_PLAN_FAILED";

export const RATE_CARD = "RATE_CARD";
export const RATE_CARD_SUCCEDED = "RATE_CARD_SUCCEDED";
export const RATE_CARD_FAILED = "RATE_CARD_FAILED";

export const PLAN_SIZE_CHANGE = "PLAN_SIZE_CHANGE";
export const PLAN_SIZE_CHANGE_SUCCEDED = "PLAN_SIZE_CHANGE_SUCCEDED";
export const PLAN_SIZE_CHANGE_FAILED = "PLAN_SIZE_CHANGE_FAILED";

export const OPTED_PLAN = "OPTED_PLAN";
export const CLOSE_CART = "CLOSE_CART";
export const CHECK_OUT_PAYMENT = "CHECK_OUT_PAYMENT";
export const CHECK_OUT_PAYMENT_SUCCEDED = "CHECK_OUT_PAYMENT_SUCCEDED";
export const CHECK_OUT_PAYMENT_FAILED = "CHECK_OUT_PAYMENT_FAILED";
export const PAYMENT_CLOSE = "PAYMENT_CLOSE";
export const PAYMENT_WEBHOOK = "PAYMENT_WEBHOOK";
export const PAYMENT_WEBHOOK_SUCCEEDED = "PAYMENT_WEBHOOK_SUCCEEDED";
export const PAYMENT_WEBHOOK_FAILED = "PAYMENT_WEBHOOK_FAILED";
export const LOAD_DASHBOARD_GRAPH_DETAILS = "LOAD_DASHBOARD_GRAPH_DETAILS";
export const LOAD_DASHBOARD_GRAPH_DETAILS_SUCCEEDED = "LOAD_DASHBOARD_GRAPH_DETAILS_SUCCEEDED";
export const LOAD_DASHBOARD_GRAPH_DETAILS_FAILED = "LOAD_DASHBOARD_GRAPH_DETAILS_FAILED";
export const LIST_SELECTED = "LIST_SELECTED";

export const PAYMENT_ACKNOWLEDGE = "PAYMENT_ACKNOWLEDGE";

export const USER_CURRENT_PLAN = "USER_CURRENT_PLAN";
export const USER_CURRENT_PLAN_FAILED = "USER_CURRENT_PLAN_FAILED";
export const USER_CURRENT_PLAN_SUCCEDED = "USER_CURRENT_PLAN_SUCCEDED";

export const USER_PAST_UPLOADS = "USER_PAST_UPLOADS";
export const USER_PAST_UPLOADS_FAILED = "USER_PAST_UPLOADS_FAILED";
export const USER_PAST_UPLOADS_SUCCEDED = "USER_PAST_UPLOADS_SUCCEDED";
export const CLEAR_USER_PAST_UPLOADS = "CLEAR_USER_PAST_UPLOADS";

export const SETTINGS_PAYMENT_HISTORY = "SETTINGS_PAYMENT_HISTORY";
export const SETTINGS_PAYMENT_HISTORY_SUCCEEDED = "SETTINGS_PAYMENT_HISTORY_SUCCEEDED";
export const SETTINGS_PAYMENT_HISTORY_FAILED = "SETTINGS_PAYMENT_HISTORY_FAILED";
export const CLEAR_SETTINGS_PAYMENT_HISTORY = "CLEAR_SETTINGS_PAYMENT_HISTORY";

export const RECURRING_PAYMENT = "RECURRING_PAYMENT";
export const RECURRING_PAYMENT_SUCCEEDED = "RECURRING_PAYMENT_SUCCEEDED";
export const RECURRING_PAYMENT_FAILED = "RECURRING_PAYMENT_FAILED";
//General Settings


export const LOAD_COMPANY_PROFILE_INFO = "LOAD_COMPANY_PROFILE_INFO";
export const LOAD_COMPANY_PROFILE_SUCCESS = "LOAD_COMPANY_PROFILE_SUCCESS";
export const LOAD_COMPANY_PROFILE_ERROR = "LOAD_COMPANY_PROFILE_ERROR";

export const SAVE_USER_COUNTRY = "SAVE_USER_COUNTRY";
export const SAVE_USER_COUNTRY_SUCCESS = "SAVE_USER_COUNTRY_SUCCESS";
export const SAVE_USER_COUNTRY_FAILURE = "SAVE_USER_COUNTRY_FAILURE";

export const LOAD_PROFILE_DETAILS = "LOAD_PROFILE_DETAILS";
export const LOAD_PROFILE_DETAILS_SUCCEEDED = "LOAD_PROFILE_DETAILS_SUCCEEDED";
export const LOAD_PROFILE_DETAILS_FAILED = "LOAD_PROFILE_DETAILS_FAILED";

export const UPDATE_PROFILE_DETAILS = "UPDATE_PROFILE_DETAILS";
export const UPDATE_PROFILE_DETAILS_SUCCEEDED = "UPDATE_PROFILE_DETAILS_SUCCEEDED";
export const UPDATE_PROFILE_DETAILS_FAILED = "UPDATE_PROFILE_DETAILS_FAILED";

export const UPDATE_PASSWORD = "UPDATE_PASSWORD";
export const UPDATE_PASSWORD_SUCCEEDED = "UPDATE_PASSWORD_SUCCEEDED";
export const UPDATE_PASSWORD_FAILED = "UPDATE_PASSWORD_FAILED";

export const PROFILE_HANDLE_CHANGE = "PROFILE_HANDLE_CHANGE";
export const PASSWORD_HANDLE_CHANGE = "PASSWORD_HANDLE_CHANGE";
export const CLEAR_PASSWORD = "CLEAR_PASSWORD";

//Forgot Password
export const FORGOT_PASSWORD_HANDLE_CHANGE = "FORGOT_PASSWORD_HANDLE_CHANGE";

export const FORGOT_PASSWORD_ACTION = "FORGOT_PASSWORD_ACTION";
export const FORGOT_PASSWORD_ACTION_SUCCEEDED = "FORGOT_PASSWORD_ACTION_SUCCEEDED";
export const FORGOT_PASSWORD_ACTION_FAILED = "FORGOT_PASSWORD_ACTION_FAILED";

//Resend Activation
export const RESEND_ACTIVATION_HANDLE_CHANGE = "RESEND_ACTIVATION_HANDLE_CHANGE";

export const RESEND_ACTIVATION_ACTION = "RESEND_ACTIVATION_ACTION";
export const RESEND_ACTIVATION_ACTION_SUCCEEDED = "RESEND_ACTIVATION_ACTION_SUCCEEDED";
export const RESEND_ACTIVATION_ACTION_FAILED = "RESEND_ACTIVATION_ACTION_FAILED";

//Reset  Password

export const RESET_PASSWORD_ACTION = "RESET_PASSWORD_ACTION";
export const RESET_PASSWORD_ACTION_SUCCEEDED = "RESET_PASSWORD_ACTION_SUCCEEDED";
export const RESET_PASSWORD_ACTION_FAILED = "RESET_PASSWORD_ACTION_FAILED";

export const TODAY = "1D";
export const WEEK = "7D";
export const MONTH = "1M";
export const THREEMONTHS = "3M";

export const DATE_FORMAT = "DD-MMM-YY";
export const DISPLAY_DATE_FORMAT = "DD-MMM-YYYY HH:MM:SS";

export const TRIAL_DAY_CREDITS = 50;
export const PAYMENT_URL_TIER1 =
  "https://mirabeldev-qa.magazinemanager.com/Intranet/Members/AR/RoutePaymentGateway.aspx?portal=true&key=";
export const PAYMENT_URL_DOMAIN_TIER1 = "mirabeldev-qa.magazinemanager.com";
export const SIGNUP_URL_TIER1 = "http://test.emailsnow.net/signup";
export const PAYMENT_URL_STAGING =
  "https://tsqb.magazinemanager.biz/Intranet/Members/AR/RoutePaymentGateway.aspx?portal=true&key=";
export const PAYMENT_URL_DOMAIN_STAGING = "tsqb.magazinemanager.biz";
export const PAYMENT_URL_PROD =
  "https://tech.magazinemanager.com/Intranet/Members/AR/RoutePaymentGateway.aspx?portal=true&key=";
export const PAYMENT_URL_DOMAIN_PROD = "tech.magazinemanager.com";
export const SIGNUP_URL_PROD = "https://cleanyourlist.mirabeltechnologies.com/signup";
export const SCRIPT_URL =
  process.env.REACT_APP_ENV == "production"
    ? "https://d1vg5xiq7qffdj.cloudfront.net/Asyncload.js?isUb=1&fpkey=" +
      String(new Date().getMonth() + 1) +
      String(new Date().getFullYear()) +
      String(Math.round(parseInt(new Date().getDate() / 7), 0) + 1) +
      "&encsid=7GWsCn8FFps,&enccid=7GWsCn8FFps,&wsid=MQ,,&trackingUrl=HIfoicOddMFsPj6pIhUag2wljpopK4yI9456300cf5g,"
    : process.env.REACT_APP_ENV == "staging"
    ? "https://d7s2gzyubkqwh.cloudfront.net/Asyncload.js?isUb=1&fpkey=" +
      String(new Date().getMonth() + 1) +
      String(new Date().getFullYear()) +
      String(Math.round(parseInt(new Date().getDate() / 7), 0) + 1) +
      "&encsid=7GWsCn8FFps,&enccid=QYWhXewP1yc,&wsid=MQ,,&trackingUrl=2PtuCvDuCGT5LwTmxa5wjl35YCAFpweh2NUvhYjS7AObQ-U15ZcpFw,,"
    : "https://d7s2gzyubkqwh.cloudfront.net/Asyncload.js?isUb=1&fpkey=" +
      String(new Date().getMonth() + 1) +
      String(new Date().getFullYear()) +
      String(Math.round(parseInt(new Date().getDate() / 7), 0) + 1) +
      "&encsid=7GWsCn8FFps,&enccid=QYWhXewP1yc,&wsid=MQ,,&trackingUrl=2PtuCvDuCGT5LwTmxa5wjl35YCAFpweh2NUvhYjS7AObQ-U15ZcpFw,,";
export const GOOGLE_TAG_CODE =
  process.env.REACT_APP_ENV == "production"
    ? "GTM-KJ5X2N6"
    : process.env.REACT_APP_ENV == "staging"
    ? "GTM-KJ5X2N6"
    : "GTM-KJ5X2N6";



// WEBPACK FOOTER //
// ./src/common/constants.js